import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../../config/URL";
import toast from "react-hot-toast";
import ImageURL from "../../../config/ImageURL";

function AffiliatePayoutView() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`admin/affiliate-payout/show/${id}`);
      setData(response.data.data);
    } catch (error) {
      toast.error("Error Fetching Data ", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  return (
    <section className="px-4">
      {loading ? (
        <div className="loader-container">
          <div className="loader">
            <svg viewBox="0 0 80 80">
              <circle cx="40" cy="40" r="32"></circle>
            </svg>
          </div>
        </div>
      ) : (
        <>
          <div className="card shadow border-0 mb-3">
            <div className="row p-3">
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <h3 className="ls-tight">View Affiliate Payout</h3>
                </div>
                <div>
                  <Link to="/affiliate-payout">
                    <button type="button" className="btn btn-light btn-sm me-2">
                      <span>Back</span>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div
            className="container card shadow border-0"
            style={{ minHeight: "80vh" }}
          >
            <div className="row mt-5 p-3">
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">User</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.user_id || ""}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Amount</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      :{" "}
                      {data?.amount
                        ? new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 0,
                          }).format(data.amount)
                        : "-"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Status</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.status || ""}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Requested Date</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      :{" "}
                      {data?.requested_at
                        ? data.requested_at.split(" ")[0]
                        : "-"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Paid Date</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.paid_at ? data.paid_at.split(" ")[0] : "-"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Payment Mode</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.payment_mode || ""}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Transaction ID</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.transaction_id || "-"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Attachment</p>
                  </div>
                  <div className="col-6">
                    {data?.attachment ? (
                      data.attachment.match(/\.(jpeg|jpg|gif|png)$/) ? (
                        <img
                          src={`${ImageURL}${data.attachment}`}
                          alt="attachment"
                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                          className="img-thumbnail"
                        />
                      ) : (
                        <a
                          href={`${ImageURL}${data.attachment}`}
                          download
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bi bi-download me-1"></i> Download
                        </a>
                      )
                    ) : (
                      <p className="text-muted">No attachment</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
}

export default AffiliatePayoutView;
